// TODO(A): lộ trình theo ghế thật khi có dữ liệu. Số MẪU theo script board Mint-Training (SEATS · P · defPath).

export interface Seat {
  code: string;
  k: string;
  /** số người đang giữ ghế */
  n: number;
}

export const SEATS: readonly Seat[] = [
  { code: 'CSD-CSO', k: 'CS · Dịch vụ khách hàng', n: 4 }, { code: 'CSD-BKG', k: 'Booking', n: 4 },
  { code: 'SALE-SE', k: 'Nhân viên kinh doanh', n: 3 }, { code: 'SALE-MGR', k: 'Trưởng phòng kinh doanh', n: 1 },
  { code: 'OPS-DOC', k: 'Chứng từ / Hải quan', n: 4 }, { code: 'OPS-FLD', k: 'Hiện trường', n: 3 },
  { code: 'TRD-DRV', k: 'Tài xế', n: 8 }, { code: 'TRD-DSP', k: 'Điều độ', n: 1 }, { code: 'ACC-CP', k: 'Kế toán chi phí', n: 2 },
];

export interface PathItem { k: string; d: string; done: boolean }
export interface PathStep { k: string; when: string; items: readonly PathItem[] }

const it = (k: string, d: string, done: 0 | 1): PathItem => ({ k, d, done: done === 1 });

const DEFAULT_PATH: readonly PathStep[] = [
  { k: 'Nhập môn', when: 'tuần 1', items: [it('Nội quy & công cụ HANA Ezy', '20 ph', 1), it('Kiêm nhiệm & luật duyệt', '7 ph', 1)] },
  { k: 'Nghiệp vụ chính', when: 'tuần 2–3', items: [it('Gửi bill qua hệ thống', '18 ph', 1), it('DEM/DET & báo khách', '12 ph', 0), it('Release B/L theo mức nợ', '12 ph', 0)] },
  { k: 'Nâng cao', when: 'tháng 2', items: [it('Tư vấn HS & form C/O', '25 ph', 0), it('Xử lý cargo claim', '15 ph', 0)] },
  { k: 'Định kỳ', when: 'mỗi quý', items: [it('Cập nhật SOP mới', '—', 0)] },
];

const PATHS: Record<string, readonly PathStep[]> = {
  'TRD-DRV': [
    { k: 'Nhập môn', when: 'tuần 1', items: [it('An toàn lái xe container đêm', '14 ph', 1), it('Quy trình ảnh ePOD trên HANA Mov', '6 ph', 1)] },
    { k: 'Nghiệp vụ', when: 'tuần 2', items: [it('Cắt mooc / móc mooc / lưu mooc', '10 ph', 0), it('Nhập chi phí chuyến', '8 ph', 0)] },
    { k: 'Định kỳ', when: 'mỗi 6 tháng', items: [it('Ôn an toàn & kiểm tra', '15 ph', 0)] },
  ],
};

export const pathOf = (seat: string): readonly PathStep[] => PATHS[seat] ?? DEFAULT_PATH;
export const pathItems = (steps: readonly PathStep[]): PathItem[] => steps.flatMap((x) => [...x.items]);
